export const Base_URL_TV = `https://api.stockwiseanalytics.com/tv`  
